export default __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.94f2f163.otf";